module.exports = __webpack_public_path__ + "img/toonhq-pride-march.84139714.webp";